<template>
  <div class="container px-4 m-auto sm:px-0">
    <div v-if="cartItems.length" class="mt-6 overflow-hidden border border-gray-200 rounded-lg shadow" v-lazy-container="{ selector: 'img' }">
      <h3 class="px-3 py-2 text-sm font-semibold text-white rounded-lg bg-primary md:text-base">عدد المنتجات {{ cartItems.length }}</h3>
      <div class="p-3">
        <div class="table-container">
          <table class="w-full overflow-x-auto">
            <thead class="text-sm text-gray-800 bg-gray-100 rtl:text-right ltr:text-left md:text-base">
              <tr>
                <th class="px-2 py-1 text-xs sm:text-base rtl:rounded-tr-lg rtl:rounded-br-lg ltr:rounded-tl-lg ltr:rounded-bl-lg">صورة المنتج</th>
                <th class="px-2 py-1 text-xs sm:text-base">اسم المنتج</th>
                <th class="px-2 py-1 text-xs sm:text-base">{{ t('product_color') }}</th>
                <th class="px-2 py-1 text-xs sm:text-base">{{ t('product_size') }}</th>
                <th class="px-2 py-1 text-xs sm:text-base">{{ t('product_price') }}</th>
                <th class="px-2 py-1 text-xs text-center sm:text-base">{{ t('item_quantity') }}</th>
                <th class="px-2 py-1 text-xs sm:text-base">{{ t('total') }}</th>
                <th class="px-2 py-1 text-xs sm:text-base rtl:rounded-tl-lg rtl:rounded-bl-lg ltr:rounded-tr-lg ltr:rounded-br-lg"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in cartItems">
                <td class="p-2" v-lazy-container="{ selector: 'img' }">
                  <a class="flex content-center justify-start w-full" :href="item.product_route">
                    <figure class="hidden w-16 h-16 p-1 border border-gray-200 rounded-md md:block rtl:ml-3 ltr:mr-3">
                      <img class="object-contain w-full h-full" :data-src="item.image">
                    </figure>
                  </a>
                </td>
                <td class="p-2">
                  <span class="text-xs font-semibold price text-primary md:text-sm">{{ item.product_name }}</span>
                </td>
                <td class="p-2">
                  <span class="text-xs font-semibold price text-primary md:text-sm">{{ item.product_color }}</span>
                </td>
                <td class="p-2">
                  <span class="text-xs font-semibold price text-primary md:text-sm">{{ item.product_size }}</span>
                </td>
                <td class="p-2">
                  <span class="text-xs font-semibold price text-primary md:text-sm">{{ item.product_price }}</span>
                </td>
                <!-- <td class="p-2">
                  <span class="text-xs font-semibold price text-primary md:text-sm">{{ item.final_price }}</span>
                </td> -->
                <td class="p-2 text-center">
                  <number-input @change="updateQuantity($event , item.quantity, item.id)" :value="item.quantity" size="small"
                                :min="1" :max="5" :inputtable="false" inline center controls></number-input>

<!--                  <span class="text-xs font-semibold price text-primary md:text-sm">{{ item.quantity }}</span>-->
                </td>
                <td class="p-2">
                  <span class="text-xs font-semibold sub-total text-primary md:text-sm">{{  item.total }} {{ t('payment_currency') }}</span>
                </td>
                <td class="p-2">
                  <a @click="deleteItem(item.id)" class="delete cart_remove">
                    <i class="text-base far fa-trash-alt md:text-lg text-secondary-300"></i>
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
        </div><!--end table-container-->
        <div class="flex justify-end mt-6">
          <div class="w-full ml-0 mr-0 sm:w-8/12 lg:w-4/12 sm:rtl:ml-1/6 sm:ltr:mr-10 ">
          <div class="flex content-center justify-between text-xs total md:text-base">
            <span class="font-semibold text-gray-600">{{ t('total') }}</span>
            <span class="font-semibold update_price text-secondary-300" id="discount_price">
              {{ userCart.total }}
              <span class="currency">{{ t('payment_currency') }} </span>
            </span>
          </div>
        </div>
      </div>
      <div class="p-3 text-xs text-center button-all sm:rtl:text-left sm:ltr:text-right sm:p-6 md:text-base sm:mt-4">
        <a href="/cart/checkout" class="inline-block px-6 py-2 mb-3 font-semibold text-white rounded-lg sm:mb-0 bg-secondary-300 sm:rtl:ml-5 sm:ltr:mr-5 hover:bg-primary">
          {{ t('cart_confirm') }}
        </a>
        <a href="/" class="inline-block px-6 py-2 font-semibold text-white rounded-lg bg-secondary-300 hover:bg-primary">
          {{ t('cart_continue') }}
        </a>
      </div><!--end button-all-->
    </div>
  </div>
  <div v-else class="container px-4 m-auto sm:px-0">
    <h3 class="mb-4 text-sm font-bold md:text-base">{{ t('cart') }}</h3>
    <div class="p-3 mt-6 overflow-hidden border border-gray-200 rounded-lg shadow">
      
      <img class="object-contain w-full h-84" src="/front/img/illustrations/empty_cart.svg">
      <p class="text-lg text-center text-primary ">{{ t('continue_message') }}</p>
      <div class="p-3 text-xs text-center button-all sm:rtl:text-left sm:ltr:text-right sm:p-6 md:text-base sm:mt-4">
        <a href="/" class="inline-block px-6 py-2 mb-3 font-semibold text-white rounded-lg sm:mb-0 bg-secondary-300 sm:rtl:ml-5 sm:ltr:mr-5 hover:bg-primary">
          {{ t('cart_continue') }}
        </a>
      </div><!--end button-all-->
    </div>
  </div>
</div>
</template>

<script>
  import NumberInput from '@chenfengyuan/vue-number-input';
  import axios from 'axios';
  import trans from './translation/checkout.json';
  export default {
    name: "Cart",
    props: {
      user: {
        type: Object,
        required: true
      },
      sitelocale:{
        type: String,
        required: true
      },
      url: String,
    },
    components: {
      NumberInput
    },

    data: () => ({
      userCart: [],
      cartItems: [],
      coupon: null,
      coupon_code: '',
    }),
    methods: {
      loadCart() {
        axios.get(this.url).then(({data}) => {
          this.userCart = data.cart;
          this.cartItems = data.items
          this.coupon = data.coupon
        });
      },
      updateQuantity(newValue , OldValue, cart) {
        if(newValue != OldValue){
          axios.patch(`/carts/${cart}/update`, {'quantity' : newValue }).then(({data}) => {
            this.userCart = data.cart;
            this.cartItems = data.items
          });
        }
      },
      deleteItem(cart) {
        axios.delete(`/carts/${cart}/delete`).then(({data}) => {
          this.userCart = data.cart;
          this.cartItems = data.items;
          let toaster = this.$toasted;
          toaster.success(data.message);
          $('.cart-counter').text(this.cartItems.length);
          $('.cart-counter').addClass('shake-animation').delay(1000).queue(function (next) {
            $(this).removeClass('shake-animation');
            next();
          });
        });
      },
      addCoupon(code) {
        axios.post(`/coupons/`, {coupon_code : code}).then(({data}) => {
          this.userCart = data.cart;
          this.cartItems = data.items;
          this.coupon = data.coupon;
          let toaster = this.$toasted;
          toaster.success(data.message);
        }).catch(errors => {
          let toaster = this.$toasted;
          toaster.error(errors.response.data.message);
        });
      },
      removeCoupon(code) {
        axios.delete(`/coupons/${code}`).then(({data}) => {
          this.coupon_code = '';
          this.loadCart();
          let toaster = this.$toasted;
          toaster.success(data.message);
        });
      },
    },
    mounted() {
      this.$translate.setLang(this.sitelocale);
    },
    locales: trans,
    created() {
      this.loadCart();
    },
    computed: {
      total_discount: function(){
        return this.cartItems.reduce(function(total, item){
          return total + parseFloat(item.discount);
        },0);
      }
    }
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/front/components/Cart.vue